import { render, staticRenderFns } from "./AssignmentTaskFilters.vue?vue&type=template&id=24480da6"
import script from "./AssignmentTaskFilters.vue?vue&type=script&lang=js"
export * from "./AssignmentTaskFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports